import React from 'react';
import { VideoModal } from 'venn-components';
import { useTheme } from 'styled-components';

export const BlockAssignmentTutorialModal = ({ onClose }: { onClose: () => void }) => {
  const { Videos } = useTheme();

  if (!Videos.blockMultiselectOnboarding) {
    return null;
  }

  return (
    <VideoModal
      onClose={onClose}
      trackHeartbeat={() => {}}
      title="How to set inputs on multiple blocks"
      isInitiallyMuted
    >
      <source src={Videos.blockMultiselectOnboarding} type="video/mp4" />
    </VideoModal>
  );
};
